import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// Testing shortcuts (skip / reset buttons) are shown only when the backend says
// they are enabled for the current caller: DEBUG_TOOLS=true (local) or a seeded
// player test account. The backend also refuses the debug endpoints otherwise,
// so hiding the buttons is cosmetic, not the protection.
const cache = new Map(); // access token -> promise; one /api/debug/status per login

export function fetchDebugTools() {
  const token = localStorage.getItem("access_token") || "";
  if (!cache.has(token)) {
    cache.set(token, fetch("/api/debug/status", {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then((r) => (r.ok ? r.json() : { debug_tools: false }))
      .then((d) => d.debug_tools === true)
      .catch(() => false));
  }
  return cache.get(token);
}

const useDebugTools = () => {
  const [enabled, setEnabled] = useState(false);
  // Re-check on navigation: NavBar and the banner mount once (before login), and the
  // answer depends on who is logged in. Cached per token, so this is cheap.
  const { pathname } = useLocation();
  useEffect(() => {
    let alive = true;
    fetchDebugTools().then((v) => alive && setEnabled(v));
    return () => { alive = false; };
  }, [pathname]);
  return enabled;
};

// Debug-only jump to any step (bypasses the server's transition rules; logged).
export async function debugSetStep(authToken, progressStep) {
  return fetch("/api/debug/progress", {
    method: "PUT",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${authToken}` },
    body: JSON.stringify({ progress_step: progressStep }),
  });
}

export default useDebugTools;
